// @flow
/** @jsx h */
import { h, Fragment } from 'preact';
import { useEffect } from 'preact/hooks';
import { styled } from 'goober';

const Container = styled('div')`
  background: #ed5b7f;
  border-radius: 8px;
  max-width: 378px;
  width: 95%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 22px;

  transition: opacity 0.3s ease-out, visibility 0s linear 0.3s;
  animation: animateToast 0.2s ease-out;
  @keyframes animateToast {
    0% {
      opacity: 0;
      scale: 0;
    }
    100% {
      opacity: 1;
      scale: 1;
    }
  }

  .toastMsg {
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    color: #ffffff;
    margin-left: 7px;
  }
`;

const ToastBox = (props) => {
  const { msg, autoHideduration = 3000, open, setOpen } = props;

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpen(false);
    }, autoHideduration);
    return () => clearTimeout(timer);
  }, [open]);

  return (
    <Fragment>
      {open && (
        <Container>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'>
            <circle cx='12' cy='12' r='11' stroke='white' stroke-width='2' />
            <path
              d='M12.9946 6.72852L12.8259 14.1228H11.1793L11.0156 6.72852H12.9946ZM12.0026 17.3137C11.6923 17.3137 11.4264 17.2047 11.2048 16.9865C10.9867 16.7683 10.8776 16.5024 10.8776 16.1887C10.8776 15.8819 10.9867 15.6194 11.2048 15.4012C11.4264 15.1831 11.6923 15.074 12.0026 15.074C12.306 15.074 12.5685 15.1831 12.7901 15.4012C13.0151 15.6194 13.1276 15.8819 13.1276 16.1887C13.1276 16.3967 13.0747 16.5859 12.969 16.7564C12.8668 16.9268 12.7304 17.0632 12.5599 17.1654C12.3929 17.2643 12.2071 17.3137 12.0026 17.3137Z'
              fill='white'
            />
          </svg>
          <div className='toastMsg'>{msg}</div>
        </Container>
      )}
    </Fragment>
  );
};

export default ToastBox;



// WEBPACK FOOTER //
// ./components/salesApp/ToastBox.js